<template>
  <v-app>
    <v-app-bar app elevation="6" class="v-navigation-drawer--mini-variant">
      <v-img href='https://sasapay.co.ke/' target="blank"  max-height="230" max-width="190" src="@/assets/sp/logoo.jpg"/>
      <!-- <v-btn v-if="$vuetify.breakpoint.smAndUp"  color="primary" href='https://sasapay.co.ke/' target="blank" class="mr-3"> SASAPAY MAIN</v-btn> -->
      <!-- <v-toolbar-title  v-if="$vuetify.breakpoint.smAndUp">Developers</v-toolbar-title> -->
      <v-spacer/>
     
      <v-btn v-if="$vuetify.breakpoint.smAndUp"  text color="primary" @click="$router.push({name:'Landing'})">HomePage</v-btn>
      <!-- <v-btn v-if="$vuetify.breakpoint.smAndUp"  text color="primary" @click="$router.push({name:'SDK'})">SDKs</v-btn> -->
      <v-btn v-if="isLoggedIn" :small="$vuetify.breakpoint.smAndDown" color="primary" to="/dashboard/applications" class="mr-3">Login</v-btn>
      <v-btn v-if="isLoggedIn" :small="$vuetify.breakpoint.smAndDown" color="error" @click="$store.dispatch('Auth/logout')">Logout</v-btn>
      <v-btn v-if="!isLoggedIn" color="error"  @click="$router.push({name:'Register'})">Register</v-btn> &nbsp;
      <v-btn v-if="!isLoggedIn" color="error"  @click="$router.push({name:'Login'})">Sign In</v-btn>
    </v-app-bar>
    <v-main>
      <router-view />
    </v-main>
    <Footer/>
  </v-app>
</template>

<script>
import {appName} from "@/environment";
import {AuthService} from "@/packages/auth";
import Footer from "@/packages/Landing/components/Footer.vue";  

export default {
  name: "Landing",
  components: {Footer},

  data: () => ({
    isMobile: false,
    drawer: false,
    group: null,
    mini: false,
    tab: null,
    items: [
      'web', 'shopping', 'videos', 'images', 'news',
    ],
  }),
  computed: {
    appName(){
      return appName
    },
    isLoggedIn(){
      return AuthService.check()
    }
  },
  methods: {
    responsiveLayout(){
      this.drawer=!this.drawer
      return !this.isMobile
    }
  },
  watch: {
    group () {
      this.drawer = false
    },
  },
}
</script>

<style scoped>

</style>
